import PinBase from './components/pins-base'
import PropTypes from 'prop-types'
import { pinsStatusVariantOptions, pinsVariantOptions } from './constants'
import { Closed, ProgressCircle } from './components/pins-status'

const PinComponent = ({
  variant = pinsVariantOptions['GRADIENT-GRAY'],
  size = 50,
  counter = null,
  colorCounter = 'white',
  isInactive = false,
  scale = 9.5,
  translate = '2.75, 2',
  percentage = null,
  iconStatus = pinsStatusVariantOptions.PROGRESS,
  ...props
}) => {
  if (percentage == null) {
    return (
      <PinBase
        variant={variant}
        size={size}
        counter={counter}
        colorCounter={colorCounter}
        isInactive={isInactive}
        scale={scale}
        translate={translate}
        {...props}
      >
        {iconStatus === pinsStatusVariantOptions.CLOSED && <Closed />}
      </PinBase>
    )
  }

  return (
    <PinBase
      variant={variant}
      size={size}
      counter={counter}
      colorCounter={colorCounter}
      isInactive={isInactive}
      scale={scale}
      translate={translate}
      {...props}
    >
      {iconStatus === pinsStatusVariantOptions.CLOSED ? (
        <Closed />
      ) : (
        <ProgressCircle percentage={percentage} iconStatus={iconStatus} />
      )}
    </PinBase>
  )
}

PinComponent.propTypes = {
  variant: PropTypes.oneOf(Object.values(pinsVariantOptions)),
  size: PropTypes.number,
  children: PropTypes.node,
  counter: PropTypes.number,
  colorCounter: PropTypes.string,
  isInactive: PropTypes.bool,
  scale: PropTypes.number,
  translate: PropTypes.string,
  percentage: PropTypes.number,
  iconStatus: PropTypes.oneOf(Object.values(pinsStatusVariantOptions))
}

export default PinComponent
